import CityPageTemplate from "../city-template/CityPageTemplate";
import { reddingConfig } from "./data";

export default function ReddingPage() {
  return <CityPageTemplate config={reddingConfig} />;
}